import { NO_INDEX } from '@tikka/basic-types';
import { Interval, Intervals } from '@tikka/intervals/intervals';
import { MutationActions } from '../../db/mutation-actions';
import { AudioRegionWriteDto } from '../../chaat/chaat-types';

// [<AbstractClass>]
export abstract class AudioRegionActions {
  getTargetRegion() {
    const selection = this.audioSelectionRegion;
    const regionIntervals = this.currentAudioRegionIntervals;
    if (selection) {
      const intersecting = regionIntervals.rangeIntersecting(
        selection.begin,
        selection.end
      );
      if (intersecting) {
        const intervals = regionIntervals.retrieveRange(
          intersecting.begin,
          intersecting.end
        );
        // TODO do something more tolerant here
        return null;
        // if (intervals.length === 1) {
        // }
      }
      return { id: null, startTime: selection.begin, endTime: selection.end };
    } else {
      const targetRegionIndex = regionIntervals.containing(
        this.currentAudioPosition
      );
      if (targetRegionIndex !== NO_INDEX) {
        return this.currentAudioRegions[targetRegionIndex];
      } else {
        return null;
      }
    }
  }

  remove(id: string): void {
    this.mutationActions.removeChaatAudioRegion(id);
  }

  addUpdateFromAudioSelection() {
    const targetRegion = this.getTargetRegion();
    if (targetRegion) {
      this.addUpdate(targetRegion);
    }
  }

  removeFromAudioSelection() {
    const targetRegion = this.getTargetRegion();
    if (targetRegion) {
      this.remove(targetRegion.id);
    }
  }

  abstract addUpdate(data: AudioRegionWriteDto): void;
  abstract get mutationActions(): MutationActions;
  abstract get currentAudioPosition(): number;
  abstract get audioSelectionRegion(): Interval;
  abstract get currentAudioRegions(): any[]; // TODO typing
  abstract get currentAudioRegionIntervals(): Intervals;
}
